// extracted by mini-css-extract-plugin
export default {"valueText":"orders__valueText__ODi8QW","valueRow":"orders__valueRow__wB1i02"};